import {useLocation, Link} from 'react-router-dom'

export const HeaderTabs: React.FC = () => {
  const location = useLocation()

  return (
    <div className='card mb-5'>
      <div className='card-body pt-1 pb-1'>
        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/product-catalogue/manage-products' && 'active')
                }
                to='/product-catalogue/manage-products'
              >
                Manage Products
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/product-catalogue/manage-category' && 'active')
                }
                to='/product-catalogue/manage-category'
              >
                Manage Category
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === '/product-catalogue/manage-unit' && 'active')
                }
                to='/product-catalogue/manage-unit'
              >
                Manage Unit
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
